// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-VisuallyHidden-VisuallyHidden-module__VisuallyHidden";
export { _1 as "VisuallyHidden" }
